module.exports = __webpack_public_path__ + "static/media/ico_location.684ea2b1.svg";